export default (apiFetch) => async (payload) => {
  const response = await apiFetch({
    endpoint: "register-interest",
    method: "POST",
    body: payload,
    headers: {},
  });

  return await response.json();
};
